<!-- <fgb-navigation-indicator></fgb-navigation-indicator> -->
<fgb-popup-notification></fgb-popup-notification>

<ng-container *ngIf="!navigationSettings?.desktop.hidden">
  <fgb-nav-bar></fgb-nav-bar>
</ng-container>

<fgbcl-notification-toast></fgbcl-notification-toast>

<div
  id="main"
  role="main"
  [ngClass]="{
    'page-bg': !isTicketTransfer,
  }"
>
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
